import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-138">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-emerald-500" data-id="element-139">
        <path d="M32 32L26.5 26.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-140" />
        <circle cx="18" cy="18" r="11" stroke="#0F172A" strokeWidth="3" data-id="element-141" />
        <path d="M14 22L18 14L22 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-142" />
      </svg>
      <div className="flex flex-col" data-id="element-143">
        <span className="text-xl font-bold leading-none text-slate-900 tracking-tight" data-id="element-144">
          SEO PPC
        </span>
        <span className="text-xs font-bold text-emerald-600 tracking-widest uppercase" data-id="element-145">
          Co. UK
        </span>
      </div>
    </div>;
}